import tilePontePo01 from "assets/medium/PONTE-PO/01.png";
import tilePontePo02 from "assets/medium/PONTE-PO/02.png";
import tilePontePo03 from "assets/medium/PONTE-PO/03.png";
import tilePontePo04 from "assets/medium/PONTE-PO/04.png";
import tilePontePo05 from "assets/medium/PONTE-PO/05.png";
import tilePontePo06 from "assets/medium/PONTE-PO/06.png";
import tilePontePo07 from "assets/medium/PONTE-PO/07.png";
import tilePontePo08 from "assets/medium/PONTE-PO/08.png";
import tilePontePo09 from "assets/medium/PONTE-PO/09.png";
import tilePontePo10 from "assets/medium/PONTE-PO/10.png";
import tilePontePo11 from "assets/medium/PONTE-PO/11.png";
import tilePontePo12 from "assets/medium/PONTE-PO/12.png";
import tilePontePo13 from "assets/medium/PONTE-PO/13.png";
import tilePontePo14 from "assets/medium/PONTE-PO/14.png";
import tilePontePo15 from "assets/medium/PONTE-PO/15.png";
import tilePontePo16 from "assets/medium/PONTE-PO/16.png";
import tilePontePo17 from "assets/medium/PONTE-PO/17.png";
import tilePontePo18 from "assets/medium/PONTE-PO/18.png";
import tilePontePo19 from "assets/medium/PONTE-PO/19.png";
import tilePontePo20 from "assets/medium/PONTE-PO/20.png";
import tilePontePo21 from "assets/medium/PONTE-PO/21.png";
import tilePontePo22 from "assets/medium/PONTE-PO/22.png";
import tilePontePo23 from "assets/medium/PONTE-PO/23.png";
import tilePontePo24 from "assets/medium/PONTE-PO/24.png";
import tilePontePo25 from "assets/medium/PONTE-PO/25.png";
import fullImage from "assets/medium/PONTE-PO/complete.png";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const pontePo: ILevel = {
  difficulty: LevelDifficulties.medium,
  type: LevelTypes.bridge,
  name: "Ponte Po",
  fullImage,
  successDialogContent: {
    subtitle: "Hai completato il PONTE SUL PO ",
    link: `https://www.fsitaliane.it/content/fsitaliane/it/innovazione/ingegneria-e-digitalizzazione/le-grandi-opere-civili.html`,
    contents: [
      {
        text: "Un ponte di ",
        isBold: false,
      },
      {
        text: "12.652 tonnellate",
        isBold: true,
      },
      {
        text: ", ma che si slancia con ",
        isBold: false,
      },
      {
        text: "armonia e grazia",
        isBold: true,
      },
      {
        text:
          " sulle acque del fiume Po. Questa importante infrastruttura ferroviaria, a metà strada tra Ostiglia e Revere, rappresenta un importante passo avanti per la ",
        isBold: false,
      },
      {
        text: "linea Bologna-Verona",
        isBold: true,
      },
      {
        text: ". Un intervento che unisce nuove tecnologie e ",
        isBold: false,
      },
      {
        text: "soluzioni ingegneristiche d’eccellenza",
        isBold: true,
      },
      {
        text:
          ", per contribuire allo sviluppo della rete AV in Italia e rendere il ",
        isBold: false,
      },
      {
        text: "sistema dei trasporti nazionale",
        isBold: true,
      },
      {
        text: " sempre più innovativo ed efficiente.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tilePontePo01,
    tilePontePo02,
    tilePontePo03,
    tilePontePo04,
    tilePontePo05,
    tilePontePo06,
    tilePontePo07,
    tilePontePo08,
    tilePontePo09,
    tilePontePo10,
    tilePontePo11,
    tilePontePo12,
    tilePontePo13,
    tilePontePo14,
    tilePontePo15,
    tilePontePo16,
    tilePontePo17,
    tilePontePo18,
    tilePontePo19,
    tilePontePo20,
    tilePontePo21,
    tilePontePo22,
    tilePontePo23,
    tilePontePo24,
    tilePontePo25,
  ],
};
